__turbopack_context__.v({
  "root": "StackCardComponent-module__6DVxxa__root",
});
